import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db039612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "skeleton-box" }
const _hoisted_2 = { class: "article-box" }
const _hoisted_3 = { class: "minor-info-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "line"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 声明：1. 文章来源中标注带“高途”字样的版权归高途所有，未经允许不得转载，如需转载请联系我们获得授权；2. 转载文章已标明其真实来源，如涉及版权和其他问题，请联系我们删除。 ", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 查看招聘岗位 ")

import {
  ref,
  computed,
  onMounted,
  watch,
  onActivated,
  onDeactivated,
  inject,
  nextTick,
} from 'vue';
import {Skeleton, Button, Toast} from 'vant';
import {useRouter} from 'vue-router';
import {useScroll} from '@vueuse/core';
import {bindMini} from '@gaotu/open-app-sdk';
import {openMaterial, saveImageToAlbum, openWindow} from '@/bridge';
import useUa from '@/hooks/useUa';
import {publishTimeFormat} from '@/utils/timeFormat';
import CustomEmpty from '@/components/CustomEmpty.vue';
import {throttle} from '@/utils/throttle';
import useScrollList from '@/hooks/useScrollList';
import {useLongPress} from '@/hooks/useLongPress';
import {useCommentList} from '@/service/comment';
import FooterText from '@/components/FooterText.vue';
import {haboClickReport} from '@/plugins/haboConfig';
import CommonPopup from '@/components/CommonPopup.vue';
import deleteImg from '@/assets/img/isDeleted.png';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import {getUrlSearch} from '@/utils/getUrlSearch';
import MorePopup from '../MorePopup/index.vue';
import InputComponent from './InputComponent.vue';
import Comment from './Comment/index.vue';
import Recommend from './Recommend.vue';
import ImagePreview from './ImagePreview.vue';


enum ProductType {
  SPIDER = 0,
  CUSTOM = 1,
  GONGKAO = 2,
}

enum HREF_TYPE {
  FILE = 'FILE',
  HTML = 'HTML',
  ERROR = 'ERROR',
  NULL = 'NULL',
}

const __default__ = {
  name: 'Article',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    detailData: null,
    content: null,
    isFinished: { type: Boolean },
    error: null,
    firstPageFetching: { type: Boolean },
    isOut: { type: Boolean },
    refetch: null,
    changeIsTop: null
  },
  setup(__props: any) {

const props = __props as {
  detailData: InfoItem;
  content: string;
  isFinished: boolean;
  error: any; // detail 接口发生错误
  firstPageFetching: boolean;
  isOut: boolean; // 是否已下架
  refetch:(params?: {[key: string]: any} | undefined) => Promise<any>;
  changeIsTop: (isTop: boolean) => void;
}



const {statusBarHeight} = useDeviceInfo();
const {isApp, isWechat, outOpenParams} = useUa();
// 端外打开不显示查看岗位按钮
const isJobBtnShow = ref<boolean>(outOpenParams.channel !== 'browser'); // 注意这里 channel 和 app 内字段重了

// 悬浮按钮打开岗位页面
const toJobPage = () => {
  openWindow(props.detailData.radarJobUrl, 0);
  haboClickReport('JOB_BTN_CLICK', {
    infoid: props.detailData.informationId, // 资讯 id(公告 id)
  });
};

const router = useRouter();
// 评论列表数据
const informationId = +router.currentRoute.value.params.infoId as number;
const {
  firstPageRefetch: commentFirstPageRrefetch,
  firstPageError: commentFirstPageError,
  firstPageFetching: commentFirstPageFetching,
  firstPageFinished: commentFirstPageFinished,
  scrollBox,
  isLoading,
  listData,
} = useScrollList<{ commentDetail: CommentDetail }, { informationId: number }>({
  getListFunc: useCommentList,
  params: {informationId},
});
// 记录是否为刷新列表, 刷新列表时不展示骨架屏
const isRefresh = ref<boolean>(false);
const changeIsRefresh = (refresh: boolean) => {
  isRefresh.value = refresh;
};

// 监听 html 内容, 对 table 进行包裹, 支持 table 左右滑动
const handleMini = () => {
  const miniList = contentRef.value!.querySelectorAll('.toMini') as unknown as HTMLLinkElement[];
  miniList.forEach(item => {
    const {ghid: ghId, path} = item.dataset || {};
    if (ghId && path) {
      // 清除a标签的默认点击事件
      item.style.position = 'relative';
      if (isApp) {
        item.onclick = null;
        bindMini(item, {
          type: 'mini',
          weConfig: {
            ghId,
            path
          }
        });
      }
      else {
        item.onclick = () => {
          Toast('该功能请在app内使用');
        };
      }
    }
  });
};
watch(
  () => props.content,
  () => {
    if (contentRef.value && props.content) {
      // 不加 nextTick 获取到的 dom 数组长度为 0, 且取不到结构 https://www.jianshu.com/p/38cc6757c2d5
      nextTick(() => {
        handleMini();
        const tableArr = Array.from(
          contentRef.value!.getElementsByTagName('table'),
        );

        // 为 table 外面包裹 scroll 元素
        for (let i = 0; i < tableArr.length; i++) {
          tableArr[i].outerHTML = `
            <div style="overflow-x: auto; width: calc(100vw - 32px);">
              ${tableArr[i].outerHTML}
            </div>
          `;
        }
      });
    }
  },
);

// 分享弹窗
const isShowPopup = ref<boolean>(false);
const hidePopup = () => {
  isShowPopup.value = false;
};
const showPopup = () => {
  isShowPopup.value = true;
};

// 图片保存弹窗
const isShowImgSavePopup = ref<boolean>(false);
const hideImgSavePopup = () => {
  isShowImgSavePopup.value = false;
};
const showImgSavePopup = () => {
  isShowImgSavePopup.value = true;
};
const handleSaveImg = () => {
  // 保存图片
  saveImageToAlbum(imgSrcRef.value!);
  hideImgSavePopup();
};

const imgSrcRef = ref<string>();
const contentRef = ref<HTMLDivElement>();

watch(
  () => props.detailData?.title,
  (_, preState) => {
    // 接口返回数据, dom 才会挂载, 因此用 watch 监听数据
    if (!preState && props.detailData?.title && isApp) {
      nextTick(() => {
        useLongPress(
          contentRef.value!,
          (e: TouchEvent) => {
            if ((e.target as HTMLElement).tagName !== 'IMG') {
              return;
            }
            showImgSavePopup();
            imgSrcRef.value = (e.target as HTMLImageElement).src;
          },
          500,
        );
      });
    }
  },
);

const isShowImage = ref<boolean>(false); // 预览组件显隐
const previewImages = ref<string[]>([]); // 预览的图片
const startPosition = ref<number>(0); // 当前查看的图片的 index
const handleContentClick = (e: MouseEvent) => {
  // 点击预览
  if ((e.target as HTMLImageElement).tagName !== 'IMG') {
    return;
  }

  const imgs = contentRef.value?.getElementsByTagName('img') ?? [];
  // 获取文章中的图片列表
  previewImages.value = Array.from(imgs!).map(item => item.src);
  // 获取当前点击图片是第几张, 直接比较 dom 节点, 防止有两张一样的图
  startPosition.value = Array.from(imgs!).findIndex(
    item => item === (e.target as HTMLImageElement),
  );
  isShowImage.value = true;
};
const cancelShowImage = () => {
  isShowImage.value = false;
};

const sourceFormat = computed(() => {
  if (props.detailData?.source) {
    return props.detailData?.source.trim();
  }
  return '';
});
const formatTags = computed(() => {
  if (props.detailData) {
    const tagsStr
      = props.detailData?.tagInfoList?.reduce(
        (prev: string, cur: string) => `${prev}#${cur} `,
        '',
      ) ?? '';
    const attrStr
      = props.detailData?.attributeInfo?.areaNameList?.reduce(
        (prev: string, cur: string) => `${prev}#${cur} `,
        '',
      ) ?? '';
    const school = props.detailData?.attributeInfo?.schoolName ?? '';
    return `${tagsStr}${`${attrStr} `}${school ? `#${school}` : ''}`;
  }
  return '';
});

// 缓存页面定位
const scrollTop = ref<number>(0);
onDeactivated(() => {
  scrollTop.value = scrollBox.value?.scrollTop as number;
});
onActivated(() => {
  scrollBox!.value!.scrollTop = scrollTop.value;
});

const {arrivedState, y} = useScroll(scrollBox);
watch(
  () => arrivedState.top,
  () => {
    props.changeIsTop(arrivedState.top);
  },
);

const commentRef = ref<any>();
const pagePosition = ref<{ article: number; comment: number }>({
  article: 0,
  comment: 0,
});
let initialCommentPosition = 0;
const newPublishCommentNumber = ref<string>('');
const handleToggleBtn = (comment?: true, commentNumber?: string) => {
  if (pagePosition.value.comment === 0) {
    initialCommentPosition = commentRef.value.$el.offsetTop;
    pagePosition.value.comment = initialCommentPosition;
  }
  if (comment) {
    // 定位到新发表的评论
    newPublishCommentNumber.value = commentNumber!;
    return;
  }
  nextTick(() => {
    // 这里在安卓上位置不完全相等, 可能有误差, 因此用 Math.abs 处理
    if (
      y.value >= initialCommentPosition
      || Math.abs(y.value - initialCommentPosition) <= 1 // 如果当前位置低于评论标题位置, 点击跳转文章, 记录最后的评论位置
      || arrivedState.bottom // 安卓微信环境中 bottom 并不准确, 可能是由于安卓中 scrollTop 为小数, 因此下一行作为兼容处理
      || Math.round(scrollBox!.value!.scrollTop)
        + scrollBox!.value!.clientHeight
        === scrollBox!.value!.scrollHeight
    ) {
      scrollBox!.value!.scrollTop = pagePosition.value.article;
      pagePosition.value.comment = y.value;
    }
    else {
      // 跳转评论位置, 记录最后的文章位置
      scrollBox!.value!.scrollTop = pagePosition.value.comment;
      pagePosition.value.article = y.value;
    }
  });
};

const handleRouteByBtn = inject('handleRouteByBtn') as (type: 'forward' | 'backward') => void;
onMounted(() => {
  // 注册打开链接方法
  window.__openWindow = throttle((url: string, type: string) => {
    if (isApp) {
      switch (type) {
      case HREF_TYPE.FILE: {
        // 文件
        openMaterial('', url);
        break;
      }
      case HREF_TYPE.HTML: {
        // 链接
        // 站内地址直接打开新 webview
        if (url.includes('gaotu.cn') || url.includes('gaotu100.com')) {
          openWindow(
            url,
            url.includes('showNavigationBar=0') ? 0 : 1,
            url.includes('showStatusBar=0') ? 0 : 1,
          );
        }
        else {// 外链先到 /outlink
          handleRouteByBtn('forward');
          const {query} = router.currentRoute.value;
          router.push({name: 'outlink', query: {...query, url}});
        }
        break;
      }
      default: {
        // 错误处理, 也用端能力打开
        openMaterial('', url);
      }
      }
    }
    else {
      // 不在端内就直接打开外链
      window.open(url);
    }
  });
});

const handleRefresh = () => {
  props.refetch();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MorePopup, {
      "information-id": _unref(informationId),
      "detail-info": __props.detailData,
      "is-show-popup": isShowPopup.value,
      "hide-popup": hidePopup,
      "is-show-feedback": false
    }, null, 8, ["information-id", "detail-info", "is-show-popup"]),
    _createElementVNode("div", {
      ref_key: "scrollBox",
      ref: scrollBox,
      class: "article-container"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Skeleton), {
          title: "",
          class: "title-skeleton"
        }),
        _createVNode(_unref(Skeleton), {
          title: "",
          row: 2,
          class: "title-skeleton"
        }),
        _createVNode(_unref(Skeleton), {
          row: 10,
          class: "content-skeleton"
        }),
        _createVNode(_unref(Skeleton), {
          row: 5,
          class: "footer-skeleton"
        })
      ], 512), [
        [_vShow, !__props.isFinished || __props.firstPageFetching]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "info-page",
        style: _normalizeStyle({minHeight: `calc(100vh - 12px - 44px - 60px - ${_unref(statusBarHeight)})`})
      }, [
        (__props.error)
          ? (_openBlock(), _createBlock(CustomEmpty, {
              key: 0,
              type: "error",
              class: "empty",
              description: "哎呀!页面加载发生意外!",
              "on-click-btn": handleRefresh
            }))
          : (!__props.isOut && __props.detailData?.title)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h2", null, _toDisplayString(__props.detailData?.title), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_unref(sourceFormat))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(sourceFormat)), 1))
                      : _createCommentVNode("", true),
                    (_unref(sourceFormat))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_unref(publishTimeFormat)(__props.detailData?.inputTime)), 1)
                  ]),
                  _createElementVNode("div", {
                    ref_key: "contentRef",
                    ref: contentRef,
                    class: _normalizeClass(
              __props.detailData?.productType === ProductType.CUSTOM
                ? 'article-content-custom'
                : 'article-content-spider'
            ),
                    onClick: handleContentClick,
                    innerHTML: __props.content
                  }, null, 10, _hoisted_6),
                  _createVNode(CommonPopup, {
                    "manage-text": "保存图片",
                    "is-show-popup": isShowImgSavePopup.value,
                    "handle-manage": handleSaveImg,
                    "hide-popup": hideImgSavePopup
                  }, null, 8, ["is-show-popup"]),
                  _createElementVNode("footer", null, [
                    (_unref(sourceFormat))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 来源：" + _toDisplayString(_unref(sourceFormat)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, _toDisplayString(_unref(formatTags)), 1),
                    _hoisted_8
                  ])
                ]),
                _createVNode(Recommend, {
                  "comment-show": _unref(listData)?.canUse
                }, null, 8, ["comment-show"]),
                (_unref(listData)?.canUse)
                  ? (_openBlock(), _createBlock(Comment, {
                      key: 0,
                      ref_key: "commentRef",
                      ref: commentRef,
                      "can-comment": _unref(listData)?.canComment,
                      "detail-data": __props.detailData,
                      "first-page-fetching": __props.firstPageFetching,
                      "first-page-finished": _unref(commentFirstPageFinished),
                      "list-data": _unref(listData)?.list || [],
                      "first-page-error": _unref(commentFirstPageError),
                      "first-page-refetch": _unref(commentFirstPageRrefetch),
                      total: _unref(listData)?.pager?.total || 0,
                      "is-refresh": isRefresh.value,
                      "change-is-refresh": changeIsRefresh,
                      "new-publish-comment-number": newPublishCommentNumber.value
                    }, null, 8, ["can-comment", "detail-data", "first-page-fetching", "first-page-finished", "list-data", "first-page-error", "first-page-refetch", "total", "is-refresh", "new-publish-comment-number"]))
                  : _createCommentVNode("", true),
                (
            _unref(commentFirstPageFinished) &&
              !_unref(commentFirstPageFetching) &&
              !_unref(commentFirstPageError) &&
              _unref(listData)?.list.length > 0
          )
                  ? (_openBlock(), _createBlock(FooterText, {
                      key: 1,
                      "is-loading": _unref(isLoading),
                      "list-length": _unref(listData)?.list.length
                    }, null, 8, ["is-loading", "list-length"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (__props.isOut)
              ? (_openBlock(), _createBlock(CustomEmpty, {
                  key: 2,
                  type: "none",
                  class: "empty",
                  description: "该资讯已被删除~",
                  img: _unref(deleteImg)
                }, null, 8, ["img"]))
              : _createCommentVNode("", true)
      ], 4), [
        [_vShow, __props.isFinished && !__props.firstPageFetching]
      ])
    ], 512),
    _createVNode(ImagePreview, {
      "is-show-image": isShowImage.value,
      "preview-images": previewImages.value,
      "start-position": startPosition.value,
      "cancel-show-image": cancelShowImage
    }, null, 8, ["is-show-image", "preview-images", "start-position"]),
    (__props.detailData?.radarJobUrl && isJobBtnShow.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          class: "job-btn",
          type: "primary",
          round: "",
          onClick: toJobPage
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (
      (__props.content.length &&
        _unref(commentFirstPageFinished) &&
        !_unref(commentFirstPageFetching) &&
        !_unref(commentFirstPageError) &&
        !__props.isOut) ||
        isRefresh.value
    )
      ? (_openBlock(), _createBlock(InputComponent, {
          key: 1,
          "is-collect": __props.detailData?.hasCollect || false,
          "handle-toggle-btn": handleToggleBtn,
          "show-popup": showPopup,
          "information-id": _unref(informationId),
          total: _unref(listData)?.pager?.total || 0,
          "first-page-refetch": _unref(commentFirstPageRrefetch),
          "change-is-refresh": changeIsRefresh,
          "hide-comment": !_unref(listData)?.canComment
        }, null, 8, ["is-collect", "information-id", "total", "first-page-refetch", "hide-comment"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})